import { useTranslation } from 'react-i18next';
import * as vp from 'vopay';

type UpdateFlinksRows = {
  label: vp.UpdateFlinksLabel;
  id: vp.UpdateFlinksId;
  preset: keyof vp.TextFieldPresets | undefined;
  required: boolean;
};

const useBuildUpdateFlinksRows = (): UpdateFlinksRows[] => {
  const { t } = useTranslation('translations', { keyPrefix: 'Integrations.Flinks.Update.Form' });

  return [
    {
      label: t('flinksUrl'),
      id: vp.UpdateFlinksId.FlinksUrl,
      preset: 'text',
      required: true,
    },
  ];
};
export default useBuildUpdateFlinksRows;
